import { useCallback, useMemo } from 'react';
import { getCountries } from '@utils/common';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';

const useGetCountriesList = () => {
  const { i18n } = useTranslation();

  const countries = useMemo(() => getCountries(i18n.language), [i18n.language]);

  const [countrySearchTerm, setCountrySearchTerm] = useState<string>('');

  const filteredCountries = useMemo(() => {
    if (!countrySearchTerm.trim()) {
      return countries;
    }
    const searchLower = countrySearchTerm.toLowerCase();
    return countries
      .filter((country) => country.label.toLowerCase().includes(searchLower))
      .map((country) => {
        return { label: country.label, value: country.value };
      });
  }, [countries, countrySearchTerm]);

  const onSearchChange = useCallback((searchTerm: string) => {
    setCountrySearchTerm(searchTerm);
  }, []);

  const getCountryByCode = useCallback(
    (code: string) => {
      return countries.find((country) => country.value === code) || { label: '', value: '' };
    },
    [countries],
  );

  return {
    countries: filteredCountries,
    onSearchChange: onSearchChange,
    countrySearchTerm: countrySearchTerm,
    getCountryByCode: getCountryByCode,
  };
};

export default useGetCountriesList;
